if (!customElements.get('donavant-legado')) {
  customElements.define('donavant-legado', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const mainImage = this.querySelector('.lg-gallery__image');
      this.querySelectorAll('[data-gallery-src]').forEach(button => {
        button.addEventListener('click', () => {
          if (!mainImage || button.getAttribute('aria-pressed') === 'true') return;
          mainImage.src = button.dataset.gallerySrc;
          mainImage.removeAttribute('srcset');
          mainImage.alt = button.dataset.galleryAlt;
          this.querySelectorAll('[data-gallery-src]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        }, options);
      });
      const product = this.querySelector('.lg-product');
      const sticky = this.querySelector('[data-sticky]');
      if (product && sticky && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, { threshold: 0 });
        this.observer.observe(product);
      }
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}
